import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDGZ6d8Pjv53M-XDUp5xv500yJTOfeDBTQ",
  authDomain: "infinest-fittrackcoach.firebaseapp.com",
  projectId: "infinest-fittrackcoach",
  storageBucket: "infinest-fittrackcoach.firebasestorage.app",
  messagingSenderId: "831783976320",
  appId: "1:831783976320:web:397a9ad1b23a1a22d85565",
  measurementId: "G-FSDM8ZL4FJ"
};

const app = initializeApp(firebaseConfig);

let messaging = null;
try {
  if (typeof window !== 'undefined' && 'Notification' in window) {
    messaging = getMessaging(app);
  }
} catch (err) {
  console.log("FCM not supported:", err.message);
}

export async function requestNotificationPermission() {
  if (!messaging) return null;
  if (!('Notification' in window)) return null;

  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") return null;

    // Register service worker for FCM
    const swReg = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

    const token = await getToken(messaging, {
      serviceWorkerRegistration: swReg,
    });
    return token;
  } catch (err) {
    console.error("FCM token error:", err);
    return null;
  }
}

export function onForegroundMessage(callback) {
  if (!messaging) return () => {};
  return onMessage(messaging, (payload) => {
    callback(payload);
  });
}

export { messaging };
